import { CustomTable } from "@/components/Tables/CustomTable"
import { columns } from "./Columns"
import { useMemo, useState } from "react"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import { apiFetch } from "@/hooks/apiFetch"
import { toast } from "sonner"
import Modal from "./Model"
import { useAppSelector } from "@/lib/hooks"
import { CrudProvider, useCrudContext } from "@/context/crudContext"
import {
  OrderCrudProvider,
  useOrderCrudContext,
} from "@/context/orderCrudContext"
import { isAdminPortal } from "@/utilities/domain"
import {
  ReportBranchFilter,
  ReportBranchProvider,
  useReportBranch,
  withBranchColumn,
} from "@/components/Reports/ReportBranchFilter"

const adminColumns = withBranchColumn(columns)

export default function PurchaseList() {
  return (
    <>
      <div className="breadcrumb-card">
        <h5>Purchases</h5>
      </div>

      {isAdminPortal() ? (
        <ReportBranchProvider>
          <AdminPurchaseTable />
        </ReportBranchProvider>
      ) : (
        <OrderCrudProvider>
          <PurchaseTable />
        </OrderCrudProvider>
      )}
    </>
  )
}

function PurchaseTable() {
  const permissions = new Set(
    useAppSelector((state) => state.auth.user?.permissions ?? [])
  )
  const { openOrderDialog, setOpenOrderDialog, setSelectedOrderRow } =
    useOrderCrudContext()

  return (
    <>
      <CustomTable
        label="Purchase"
        columns={columns}
        apiPath="purchase"
        onAdd={() => setOpenOrderDialog(true)}
        onEdit={async (rowData) => {
          try {
            const purchase = await apiFetch(`purchase/${rowData.id}`)
            setSelectedOrderRow(purchase.data)
            setOpenOrderDialog(true)
          } catch (error) {
            toast.error(error.message)
          }
        }}
        showImport={permissions.has("operations-imports-create")}
        onExport={permissions.has("operations-exports-create")}
      />

      {openOrderDialog ? <Modal /> : null}
    </>
  )
}

// Company administrators review every branch's purchases, or a selected one;
// purchases are recorded on the branch portals.
function AdminPurchaseTable() {
  const { branchId } = useReportBranch()
  const branchFilter = useMemo(() => ({ branch_id: branchId }), [branchId])

  return (
    <CustomTable
      label="Purchase"
      columns={adminColumns}
      apiPath="purchase"
      addBtn={false}
      showEdit={false}
      showDelete={false}
      onExport
      hardcodedFilters={branchFilter}
      exportParams={branchFilter}
      renderFilters={() => <ReportBranchFilter sx={{ mb: 0 }} />}
    />
  )
}
